export class LogShippingTokenLimitsModel {
    maxAllowedTokens;
    numOfEnabledTokens;
}
//# sourceMappingURL=log-shipping-token-limits.js.map